import { render, staticRenderFns } from "./custom-client-placeholder.vue?vue&type=template&id=a96ecba2&scoped=true"
import script from "./custom-client-placeholder.vue?vue&type=script&lang=js"
export * from "./custom-client-placeholder.vue?vue&type=script&lang=js"
import style0 from "./custom-client-placeholder.vue?vue&type=style&index=0&id=a96ecba2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96ecba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a96ecba2')) {
      api.createRecord('a96ecba2', component.options)
    } else {
      api.reload('a96ecba2', component.options)
    }
    module.hot.accept("./custom-client-placeholder.vue?vue&type=template&id=a96ecba2&scoped=true", function () {
      api.rerender('a96ecba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "custom-client-placeholder.vue"
export default component.exports